export default __webpack_public_path__ + "static/media/flop-hit_0005_thumb.572c5163.jpg";